@if (!onlyOTP) {
<div class="notification-bar" *ngIf="infoMessage && displayInfoMessage">
  <div class="notification-content">
    <span>{{ infoMessage.message }}</span>
    <span *ngIf="infoMessage?.tryAgain" (click)="resendOtp('tryAgain')" style="text-decoration: underline; margin-left: 5px; cursor: pointer;">
      {{infoMessage.tryAgain}}
    </span>
  </div>
    <span class="notification-close" (click)="displayInfoMessage = false">
      <i class="pi pi-times"></i>
    </span>
  </div>
  
  <div class="opt-verification">
    <div class="verification-content">
      
      <div class="illustration-section">
        <div class="background-shadow"></div> 
        <div class="illustration-card">
          <div class="image-container" id="tiltImage">
            <img src="../../../assets/otp-logo.jpg" 
              alt="Verification illustration" class="illustration-image">
          </div>
        </div>
        <h2 class="verification-title">Two-Step Verification</h2>
        <p class="verification-description">
          Enter the verification code sent to your email to ensure secure access to your account.
        </p>
      </div>
  
      <div class="form-section">
        <div class="lock-icon">
          <i class="pi pi-lock"></i>
        </div>
  
        <h1 class="form-title">Verify Your Account</h1>
        <p class="form-subtitle">Enter the code we sent to your email</p>
  
        <div *ngIf="!pageLoading" class="form-card">
  
          <div class="form-group">
            <label class="form-label">Email Address</label>
            <div class="email-input">
              <i class="pi pi-envelope"></i>
              <input [(ngModel)]="loginEmail" type="email" disabled>
            </div>
          </div>
  
          <div class="otp-group" *ngIf="verifyOtpState">
            <div class="otp-label-container">
              <label class="form-label">Verification Code</label>
              <a class="resend-link" *ngIf="!waitToResend" (click)="resendOtp('')">
                <span *ngIf="!loadResend">Resend Code</span>
                <p-progressSpinner *ngIf="loadResend" [style]="{height: '20px', width: '20px'}" strokeWidth="7" animationDuration="0.5s"></p-progressSpinner>
              </a>
              <span *ngIf="waitToResend" class="resend-link">
                Resend in {{countdown}}s
              </span>
            </div>
  
            <div class="otp-inputs">
                <input type="text" maxlength="1" class="otp-input" [(ngModel)]="digit1" (input)="onOtpChange($event, 0)" (paste)="handlePaste($event)" (keypress)="restrictNumber($event)">
                <input type="text" maxlength="1" class="otp-input" [(ngModel)]="digit2" (input)="onOtpChange($event, 1)" (paste)="handlePaste($event)" (keypress)="restrictNumber($event)">
                <input type="text" maxlength="1" class="otp-input" [(ngModel)]="digit3" (input)="onOtpChange($event, 2)" (paste)="handlePaste($event)" (keypress)="restrictNumber($event)">
                <input type="text" maxlength="1" class="otp-input" [(ngModel)]="digit4" (input)="onOtpChange($event, 3)" (paste)="handlePaste($event)" (keypress)="restrictNumber($event)">
                <input type="text" maxlength="1" class="otp-input" [(ngModel)]="digit5" (input)="onOtpChange($event, 4)" (paste)="handlePaste($event)" (keypress)="restrictNumber($event)">
                <input type="text" maxlength="1" class="otp-input" [(ngModel)]="digit6" (input)="onOtpChange($event, 5)" (paste)="handlePaste($event)" (keypress)="restrictNumber($event)">
              </div>                           
            <p class="otp-hint">Enter the 6-digit verification code</p>
          </div>
  
          <button class="verify-button" [disabled]="!isOtpComplete()" [class.disabled]="!isOtpComplete()" (click)="loginVerifyOtp()" *ngIf="loginCheck">
            <span *ngIf="!btnLoading">Verify Account</span>
            <p-progressSpinner *ngIf="btnLoading" [style]="{height: '20px', width: '20px'}" strokeWidth="7" animationDuration="0.5s"></p-progressSpinner>
          </button>
  
        </div>  
        <div *ngIf="pageLoading" style="text-align: center;">
          <p-progressSpinner [style]="{height: '30px', width: '30px'}" strokeWidth="7" animationDuration="0.5s"></p-progressSpinner>
        </div>
  
      </div>
  
    </div> 
  </div>
} @else {
<div class="otp-group-new" *ngIf="verifyOtpState">
  <div class="otp-label-container">
    <label class="form-label">Verification Code</label>
  </div>
  <div class="otp-inputs only">
    <input autocomplete="new-password" type="text" maxlength="1" id="otp-1" class="otp-input" [(ngModel)]="digit1" (input)="onOtpChange($event, 0)"
      (paste)="handlePaste($event)" (keypress)="restrictNumber($event)" (keydown)="otpKeyDown($event, 0)">
    <input autocomplete="new-password" type="text" maxlength="1" id="otp-2" class="otp-input" [(ngModel)]="digit2" (input)="onOtpChange($event, 1)"
      (paste)="handlePaste($event)" (keypress)="restrictNumber($event)" (keydown)="otpKeyDown($event, 1)">
    <input autocomplete="new-password" type="text" maxlength="1" id="otp-3" class="otp-input" [(ngModel)]="digit3" (input)="onOtpChange($event, 2)"
      (paste)="handlePaste($event)" (keypress)="restrictNumber($event)" (keydown)="otpKeyDown($event, 2)">
    <input autocomplete="new-password" type="text" maxlength="1" id="otp-4" class="otp-input" [(ngModel)]="digit4" (input)="onOtpChange($event, 3)"
      (paste)="handlePaste($event)" (keypress)="restrictNumber($event)" (keydown)="otpKeyDown($event, 3)">
    <input autocomplete="new-password" type="text" maxlength="1" id="otp-5" class="otp-input" [(ngModel)]="digit5" (input)="onOtpChange($event, 4)"
      (paste)="handlePaste($event)" (keypress)="restrictNumber($event)" (keydown)="otpKeyDown($event, 4)">
    <input autocomplete="new-password" type="text" maxlength="1" id="otp-6" class="otp-input" [(ngModel)]="digit6" (input)="onOtpChange($event, 5)"
      (paste)="handlePaste($event)" (keypress)="restrictNumber($event)" (keydown)="otpKeyDown($event, 5)">
  </div>
  <div class="otp-label-container">
    <p class="otp-hint">Enter the 6-digit verification code</p>
    <a class="resend-link" *ngIf="!waitToResend" (click)="resendOtp('')">
      <span *ngIf="!loadResend">Resend Code</span>
      <p-progressSpinner *ngIf="loadResend" [style]="{height: '20px', width: '20px'}" strokeWidth="7"
        animationDuration="0.5s"></p-progressSpinner>
    </a>
    <span *ngIf="waitToResend" class="resend-link">
      Resend in {{countdown}}s
    </span>
  </div>
</div>

<button pButton [loading]="btnLoading" class="verify-button neo-btn" [disabled]="!isOtpComplete()" [class.disabled]="!isOtpComplete()" (click)="loginVerifyOtp()" *ngIf="loginCheck">
  Verify
</button>
}